import { render, staticRenderFns } from "./Lics.vue?vue&type=template&id=57a759ba&scoped=true&"
import script from "./Lics.vue?vue&type=script&lang=ts&"
export * from "./Lics.vue?vue&type=script&lang=ts&"
import style0 from "./Lics.vue?vue&type=style&index=0&id=57a759ba&scoped=true&lang=scss&"
import style1 from "./Lics.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a759ba",
  null
  
)

export default component.exports